import { createContext, useContext } from "react";

export type UploadKey = string | number;

export interface UploadRegistry {
    add: (key: UploadKey) => void;
    remove: (key: UploadKey) => void;
    has: (key: UploadKey) => boolean;
}

const noopRegistry: UploadRegistry = {
    add: () => {},
    remove: () => {},
    has: () => false,
};

const UploadRegistryContext = createContext<UploadRegistry>(noopRegistry);

/**
 * Tracks which video slots have an upload in flight, keyed by video id/hash.
 * A provider is only mounted around the project-details Downloads tab; anywhere
 * else this resolves to a no-op registry, so consumers are always safe to call.
 */
export const useUploadRegistry = (): UploadRegistry => useContext(UploadRegistryContext);

export const UploadRegistryProvider = UploadRegistryContext.Provider;
